const LoadingInput = ({ classname }: { classname?: string }) => {
  return (
    <input
      type="text"
      placeholder="Loading..."
      className={`input ${classname} `}
      disabled
    />
  );
};
export default LoadingInput;
